import styled from '@emotion/styled'

import { colors, fonts, metrics } from 'component-library/__styling/settings'
import { calcRem, breakpoint } from 'component-library/__styling/style-functions'
import { transition } from 'component-library/__styling/style-mixins'
import { conditionalStyles } from 'component-library/__styling/conditional-styles'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledButton = styled('button')(
    {
        background: 'transparent',
        fontSize: calcRem(14),
        textTransform: 'uppercase',
        fontWeight: 700,
        cursor: 'pointer',

        [breakpoint('xs')]: {
            margin: 0,
            flex: '0 0 auto',
        },

        '&:focus': {
            color: colors.white,
            outline: 'none',
        },

        '&:hover': {
            color: colors.white,
        },
    },
    ({ theme }) => ({
        ...conditionalStyles(theme.kind === 'thewest', {
            background: theme.sectionValues.primaryColor,
            color: colors.white,
            fontFamily: fonts.thewest.sansSerif,
            padding: calcRem(metrics.thewest.margins.sm),
            borderRadius: '2px',
            border: 'none',
            ...transition({ properties: ['background', 'color'] }),
            flex: '0 0 auto',
            fontSize: calcRem(11),

            '&:focus': {
                background: colors.thewest.greyKoala,
            },

            '&:hover': {
                background: colors.thewest.greyGorilla,
            },

            [breakpoint('xxs')]: {
                fontSize: calcRem(14),
            },
        }),

        ...conditionalStyles(theme.kind === 'perthnow', {
            color: colors.perthnow.blueKyanite,
            fontFamily: fonts.perthnow.heading,
            padding: calcRem(metrics.perthnow.margins.sm, 0),
            border: `1px solid ${colors.perthnow.blueKyanite}`,
            width: calcRem(130),
            display: 'block',
            margin: '0 auto',

            ...transition({ properties: ['background', 'color', 'border'] }),

            '&:focus': {
                color: colors.white,
                background: colors.perthnow.pinkThulite,
                border: `1px solid ${colors.perthnow.pinkThulite}`,
            },

            '&:hover': {
                background: colors.perthnow.blueKyanite,
                border: `1px solid ${colors.perthnow.blueKyanite}`,
            },
        }),

        ...conditionalStyles(theme.kind === 'sevennews', {
            background: themedValue(theme, {
                thewest: colors.black,
                perthnow: colors.black,
                sevennews: section => section.button.primaryColor,
            }),
            color: colors.white,
            fontFamily: fonts.sevennews.sansSerifCond,
            padding: calcRem(metrics.sevennews.margins.sm),
            borderRadius: calcRem(4),
            border: 'none',
            ...transition({ properties: ['background', 'color'] }),
            flex: '0 0 auto',
            fontSize: calcRem(15),

            '&:focus': {
                background: themedValue(theme, {
                    thewest: colors.black,
                    perthnow: colors.black,
                    sevennews: section => section.button.hoverColor,
                }),
                textDecoration: 'underline',
            },

            '&:hover': {
                background: themedValue(theme, {
                    thewest: colors.black,
                    perthnow: colors.black,
                    sevennews: section => section.button.hoverColor,
                }),
            },
        }),
    })
)
